export const filesToObject = async (_files) => {
  try {
    const res = await Promise.all(
      _files.map((file) => {
        return new Promise((resolve, reject) => {
          if (!file.type) {
            resolve(file);
          } else if (file.type.includes('jpeg') || file.type.includes('jpg') || file.type.includes('png')) {
            let reader = new FileReader();
            reader.addEventListener('load', (ev) => {
              resolve({
                fileSize: file.size,
                fileType: file.type,
                fileName: file.name,
                filePreview: ev.target.result,
                fileBlobUrl: URL.createObjectURL(file)
              });
            });
            reader.addEventListener('error', reject);
            reader.readAsDataURL(file);
          } else if (file.type.includes('pdf')) {
            resolve({
              fileSize: file.size,
              fileType: file.type,
              fileName: file.name,
              filePreview: '/static/images/preview-pay-bill.svg',
              fileBlobUrl: URL.createObjectURL(file)
            });
          } else {
            reject('This file format is not supported');
          }
        });
      })
    );
    return res;
  } catch (e) {
    throw e;
  }
};
